import React from 'react';
const CancellationPage = () => {
  return <div className="container mx-auto px-4 py-12" data-id="element-144">
      <h1 className="text-3xl font-bold mb-8 text-[#1A2B4C]" data-id="element-145">
        Cancellation Policy
      </h1>
      <div className="bg-white rounded-lg shadow-sm p-8" data-id="element-146">
        <p className="mb-6" data-id="element-147">
          At Elevatefix, we want you to feel confident in your service plan. We
          offer a simple and clear cancellation process to give you complete
          peace of mind.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-148">
          Full Refund Within 14 Days
        </h2>
        <p className="mb-6" data-id="element-149">
          You have the right to cancel your service plan within 14 days of your
          purchase. If you decide to cancel during this cooling-off period,
          you'll receive a full refund, with no questions asked. This allows you
          to review your plan and make sure it's the right fit for your needs.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-150">
          Partial Refunds After 14 Days
        </h2>
        <p className="mb-6" data-id="element-151">
          If you wish to cancel your plan after the initial 14-day period but
          within 28 days of the purchase date, you may be eligible for a partial
          refund. This is granted at our discretion and will take into account
          any services or repairs that have already been provided under your
          plan.
          <br data-id="element-152" />
          <br data-id="element-153" />
          Please note that we cannot process cancellations or refunds after 28
          days from the purchase date.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-154">How to Cancel</h2>
        <p className="mb-6" data-id="element-155">
          To cancel your service plan, please contact our customer support team.
          Once we receive your request, we will review it and process any
          eligible refund as quickly as possible. We will send you a
          confirmation once your cancellation is complete.
          <br data-id="element-156" />
          <br data-id="element-157" />
          Phone: 0800 055 4969
          <br data-id="element-158" />
          Email: dronakoirala6@gmail.com
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-159">
          Important Exclusions
        </h2>
        <p className="mb-4" data-id="element-160">
          For a number of reasons, certain circumstances are not covered by our
          service plans. These include:
          <br data-id="element-161" />
          <br data-id="element-162" />
          <span className="font-medium" data-id="element-163">Pre-existing faults:</span> Any faults
          or damage that existed before your plan's start date.
          <br data-id="element-164" />
          <br data-id="element-165" />
          <span className="font-medium" data-id="element-166">Misuse or neglect:</span> Damage caused
          by improper use, accidents, neglect, or unauthorised repairs.
          <br data-id="element-167" />
          <br data-id="element-168" />
          <span className="font-medium" data-id="element-169">Non-standard repairs:</span> Any repairs
          that go beyond the appliance's normal function.
          <br data-id="element-170" />
          <br data-id="element-171" />
          <span className="font-medium" data-id="element-172">Fraudulent use:</span> Using our
          services fraudulently or illegally will result in immediate
          cancellation of your plan without a refund.
          <br data-id="element-173" />
          <br data-id="element-174" />
          <span className="font-medium" data-id="element-175">
            Failure to follow manufacturer's instructions:
          </span>{' '}
          Appliances that have not been used or maintained according to the
          manufacturer's guidelines.
          <br data-id="element-176" />
          <br data-id="element-177" />
          If any of these exclusions apply, your plan may be immediately voided,
          and you'll no longer be eligible for repairs or refunds.
        </p>
      </div>
    </div>;
};
export default CancellationPage;